import React, { memo } from 'react';
import classNames from 'classnames';
import Button from 'src/components/helpers/Button';
import { usePopupContext } from '../../../../contexts/PopupContext';

import style from './style.module.css';

const EditEmailTemplateSendGridPopupComponent = ({
  onSave,
  onUploadFile,
  isDisabledSave,
  onOpenEditor,
  isDisabled,
}) => {
  const { closePopup } = usePopupContext();

  const handleClose = () => {
    closePopup();
  };

  const labelClassName = classNames('btn btn-xs btn-primary', isDisabled ? style.labelDisabled : null);

  return (
    <div className={style.host}>
      <div className={style.buttonGroup}>
        <label className={labelClassName}>
          <input
            accept="text/html"
            className="input-file-button"
            disabled={isDisabled}
            onChange={onUploadFile}
            type="file"
          />
          Upload
        </label>
        <span>OR</span>
        <Button className="btn-primary" disabled={isDisabled} onClick={onOpenEditor} type="button">
          Open Editor
        </Button>
      </div>
      <div className={style.buttonGroup}>
        <Button className="btn-primary" disabled={isDisabledSave} onClick={onSave} type="button">
          Save
        </Button>
        <Button onClick={handleClose} type="button">
          Close
        </Button>
      </div>
    </div>
  );
};

/** Footer component. */
export const Footer = memo(EditEmailTemplateSendGridPopupComponent);
